import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { BusinessService } from "./business.service";

export interface PermalinkResolution {
  merchantId: string;
  businessId: string;
  businessDetails: any;
  utmParams: any;
}

@Injectable({ providedIn: "root" })
export class PermalinkService {

  // ✅ Flag to tell PickUpPage the guard already resolved this
  private _resolvedByGuard = false;

  get resolvedByGuard(): boolean {
    return this._resolvedByGuard;
  }

  // ✅ This is the method the guard calls
  setResolvedByGuard(value: boolean) {
    this._resolvedByGuard = value;
  }

  constructor(private businessService: BusinessService) {}

  resolvePermalink(shortName: string, utmId: string): Observable<PermalinkResolution> {
    return this.businessService
      .getBusinessAndUTMByShortNameandUtmId(shortName, utmId)
      .pipe(
        map((result: any) => {
          const businessAndUTM =
            result?.data?.GetBusinessAndUTMByShortNameandUtmId;

          if (!businessAndUTM || !businessAndUTM.busienss) {
            throw new Error("Invalid permalink response");
          }

          const businessDetails = Array.isArray(businessAndUTM.busienss)
            ? businessAndUTM.busienss[0]
            : businessAndUTM.busienss;

          if (!businessDetails) {
            throw new Error("Invalid permalink response");
          }

          const utmParams = businessAndUTM.utmParams;

          return {
            merchantId: businessDetails.merchantId,
            businessId: businessDetails.id,
            businessDetails,
            utmParams,
          };
        })
      );
  }
}